import { env } from '@cc-shopping/platform-env';
import type { BrandIconName } from './types';

const ICON_URL = `${env.NEXT_PUBLIC_NW_URL}cdn/cc-shopping-client/shared/icons`;

export const BRAND_ICON_URL_MAP: Record<BrandIconName, string> = {
  analyze401k: `${ICON_URL}/Analyze401k.svg`,
  approved: `${ICON_URL}/Approved.svg`,
  askexperts: `${ICON_URL}/AskExperts.svg`,
  autoloans: `${ICON_URL}/AutoLoans.svg`,
  badcredit: `${ICON_URL}/BadCredit.svg`,
  balancetransfer: `${ICON_URL}/BalanceTransfer.svg`,
  banking: `${ICON_URL}/Banking.svg`,
  buildingwealth: `${ICON_URL}/BuildingWealth.svg`,
  calculator: `${ICON_URL}/Calculator.svg`,
  cashflow: `${ICON_URL}/CashFlow.svg`,
  cdrates: `${ICON_URL}/CdRates.svg`,
  compare: `${ICON_URL}/Compare.svg`,
  condo: `${ICON_URL}/Condo.svg`,
  contract: `${ICON_URL}/Contract.svg`,
  creditcard: `${ICON_URL}/CreditCard.svg`,
  creditscore: `${ICON_URL}/CreditScore.svg`,
  debt: `${ICON_URL}/Debt.svg`,
  emergencyfund: `${ICON_URL}/EmergencyFund.svg`,
  ethicalfinance: `${ICON_URL}/EthicalFinance.svg`,
  graph: `${ICON_URL}/Graph.svg`,
  handcoins: `${ICON_URL}/HandCoins.svg`,
  listmagnifyingglass: `${ICON_URL}/ListMagnifyingGlass.svg`,
  multifamilyhome: `${ICON_URL}/MultiFamilyHome.svg`,
  homeinsurance: `${ICON_URL}/HomeInsurance.svg`,
  homeimprovement: `${ICON_URL}/HomeImprovement.svg`,
  lowinterest: `${ICON_URL}/LowInterest.svg`,
  mortgage: `${ICON_URL}/Mortgage.svg`,
  networth: `${ICON_URL}/NetWorth.svg`,
  onlinebroker: `${ICON_URL}/OnlineBroker.svg`,
  openhouse: `${ICON_URL}/OpenHouse.svg`,
  personalloans: `${ICON_URL}/PersonalLoans.svg`,
  primaryresidence: `${ICON_URL}/PrimaryResidence.svg`,
  rewards: `${ICON_URL}/Rewards.svg`,
  research: `${ICON_URL}/Research.svg`,
  savings: `${ICON_URL}/Savings.svg`,
  searchmortgage: `${ICON_URL}/SearchMortgage.svg`,
  secondaryresidence: `${ICON_URL}/SecondaryResidence.svg`,
  singlehome: `${ICON_URL}/SingleHome.svg`,
  studentloans: `${ICON_URL}/StudentLoans.svg`,
  townhouse: `${ICON_URL}/TownHouse.svg`,
  zeropercent: `${ICON_URL}/ZeroPercent.svg`,
};
